import { render, staticRenderFns } from "./MovieList.vue?vue&type=template&id=4e25a2cc&scoped=true&"
import script from "./MovieList.vue?vue&type=script&lang=js&"
export * from "./MovieList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e25a2cc",
  null
  
)

export default component.exports